import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import 'tippy.js/dist/tippy.css'; // optional for styling
import Tippy from '@tippyjs/react';

import Card from './AppointmentCardStyles';
import { cardParams, LabelJSX, useImages } from './cardUtils';
import CardModal from './CardModal';
import { openFileViewer } from '../../actions';

import tooltipIcon from '../../images/common/tooltip.svg';
import rightArrow from '../../images/common/violet-arrow-right.svg';

const DEFAULT_MODAL_DATA = { cardType: '', actionType: '' };

const AppointmentCard = ({
  pendingCopay,
  status,
  cancelCharge = 0,
  modalText,
  onTap = () => { },
  letter,
  onReload,
  tooltipText,
  setRefundStatusModal,
  refundStatus,
  ...props
}) => {
  const dispatch = useDispatch();
  const [modalData, setModalData] = useState(DEFAULT_MODAL_DATA);
  const [_, headerIcon] = useImages(undefined, status.cardType);

  const handleClick = (actionType) => {
    setModalData({ cardType: status.cardType, actionType });
  };

  // Filter out Slot Type if slotType is null
  const filteredCardParams = cardParams.filter(
    (item) => item.valueKey !== 'slotType' || props.slotType
  );

  const getTooltipContent = (item) => {
    if (item.valueKey === 'slotType' && props.slotType === 'fixed') {
      return 'Please reach the centre before your appointment time to avoid missing it';
    }
    if (item.valueKey === 'slotType' && props.slotType === 'walk-in') {
      return 'Appointment will be held on first-come, first-served basis within the defined time slot.';
    }
    return props[item.tooltipKey] || item.tooltipKey;
  };

  return (
    <Card.Container
      style={{
        position: 'relative',
        overflow: 'hidden',
        ...(status &&
          status.cardType &&
          !status.cardType.includes('appointment-reschedule')
          ? {
            border: `1px solid ${status.cardType.includes('cancelled') ? '#ff7268' : '#f0f3f6'
              }`,
          }
          : {}),
        paddingBottom: props.prebookedAppointment && status.prebookedAppointment == 1 ? '16px' : '0px',
      }}
    >
      {props?.prebookedAppointment === 1 && (
        <Card.Chip>
          <Card.ChipText>Self Booked Appointment</Card.ChipText>
        </Card.Chip>
      )}
      <Card.Header onClick={onTap} style={{ marginTop: props?.prebookedAppointment == 1 ? '24px' : '0' }}>
        <Card.LogoContainer>
          <Card.Logo src={headerIcon} alt={status.title} />
        </Card.LogoContainer>
        <Card.TextContainer>
          <Card.Heading>
            {status.title}
            <Card.RightIcon src={rightArrow} />
          </Card.Heading>
          <Card.Subtitle> {status.description} </Card.Subtitle>
        </Card.TextContainer>
      </Card.Header>
      <Card.Body
        style={
          !status.questionText && !letter && status.cardType !== 'cancelled'
            ? { borderBottom: 'none' }
            : {}
        }
      >
        {filteredCardParams
          .filter((item, ind) => {
            if (props.centerRequest === 1) {
              if (
                item.valueKey !== 'doctorFees' &&
                item.valueKey !== 'doctorName'
              ) {
                //When doctor has not been assigned yet, do not show doctor name and doctor fees
                return true;
              }
            } else if (
              (props.centerRequest === 0 || props.centerRequest === null) &&
              item.valueKey !== 'vertical'
            ) {
              return true;
            }
          })
          .map((item, ind) => (
            <React.Fragment key={item.name}>
              <Card.DataRow>
                <Card.DataIconContainer>
                  <Card.DataIcon src={item.icon} alt={item.name} />
                </Card.DataIconContainer>
                <Card.DataColumn>
                  <Card.DataTextContainer>
                    <Card.DataTextSubtitle>
                      {item.name + (props[item.nameKey] || '')}
                    </Card.DataTextSubtitle>
                    <Card.DataTextSubContainer>
                      <Card.DataTextHeading
                        style={
                          ((item.value || '') +
                            (item.valueFormatter
                              ? item.valueFormatter(props[item.valueKey])
                              : props[item.valueKey]))[0] === 'A'
                            ? { marginLeft: '1.5px' }
                            : {}
                        }
                      >
                        {(item.value || '') +
                          (item.valueFormatter
                            ? item.valueFormatter(props[item.valueKey])
                            : props[item.valueKey])}
                        {item?.verticalValueKey
                          ? ' (' +
                          (item.valueFormatter
                            ? item.valueFormatter(
                              props[item.verticalValueKey]
                            )
                            : props[item.verticalValueKey]) +
                          ')'
                          : null}

                        {Boolean(item.tooltipKey) ? (
                          <Tippy content={getTooltipContent(item)}>
                            <Card.DataIcon
                              style={{ marginLeft: '5px' }}
                              src={tooltipIcon}
                            />
                          </Tippy>
                        ) : (
                          <></>
                        )}
                      </Card.DataTextHeading>

                      {pendingCopay &&
                        item.valueKey === 'doctorName' &&
                        false ? (
                        <Card.PriceContainer>
                          <Tippy content={tooltipText}>
                            <Card.DataIcon src={tooltipIcon} />
                          </Tippy>
                          <Card.PriceText>{`₹ ${pendingCopay}`}</Card.PriceText>
                        </Card.PriceContainer>
                      ) : props[item.prevValueKey] &&
                        props[item.prevValueKey] !== props[item.valueKey] &&
                        props[item.newValueKey] ? (
                        <Card.DataTextSubtitleCancel>
                          <div>
                            <Card.DataIcon
                              src={item.prevIcon}
                              alt={item.name}
                            />
                          </div>
                          <Card.DataTextSubtitleCancelText>
                            {item.valueFormatter
                              ? item.valueFormatter(props[item.prevValueKey])
                              : props[item.prevValueKey]}
                          </Card.DataTextSubtitleCancelText>
                        </Card.DataTextSubtitleCancel>
                      ) : (
                        <></>
                      )}
                    </Card.DataTextSubContainer>
                  </Card.DataTextContainer>
                </Card.DataColumn>
              </Card.DataRow>
              {ind !== filteredCardParams.length - 1 ? (
                <Card.SpaceRow />
              ) : (
                <></>
              )}
            </React.Fragment>
          ))}
        {status &&
          status.cardType &&
          !status.cardType.includes('appointment-reschedule') ? (
          <LabelJSX label={status.label} hex={status.hex} icon={status.icon} />
        ) : (
          <></>
        )}
      </Card.Body>
      {status.questionText ? (
        <>
          <Card.WarningText> {status.questionText} </Card.WarningText>
          <Card.ButtonGroup>
            <Card.ConfirmButton onClick={() => handleClick('confirm')}>
              Confirm {pendingCopay ? '& Pay' : ''}
            </Card.ConfirmButton>
            <Card.CancelButton onClick={() => handleClick('cancel')}>
              Cancel
              <span style={{ fontSize: '10px', color: '#767787' }}>
                {cancelCharge ? ` (₹ ${cancelCharge})` : ' (No Charges)'}
              </span>
            </Card.CancelButton>
          </Card.ButtonGroup>
        </>
      ) : (
        <></>
      )}
      {letter && status.cardType !== 'cancelled' ? (
        <Card.ButtonGroup>
          <Card.ConfirmLink>
            <span
              onClick={() => {
                dispatch(
                  openFileViewer({
                    contentUrl: letter,
                    type: 'pdf',
                    title: 'Cashless Letter',
                  })
                );
              }}
            >
              View Cashless Letter
            </span>
          </Card.ConfirmLink>
        </Card.ButtonGroup>
      ) : status.cardType === 'cancelled' ? (
        <Card.ButtonGroup>
          <Card.ConfirmButton
            onClick={() => {
              setRefundStatusModal(true);
              refundStatus(props.requestId);
            }}
          >
            Track Refund Status
          </Card.ConfirmButton>
        </Card.ButtonGroup>
      ) : (
        <></>
      )}
      <CardModal
        {...modalData}
        requestId={props.requestId}
        onClose={() => setModalData(DEFAULT_MODAL_DATA)}
        onReload={onReload}
        cancelCharge={cancelCharge}
        modalText={modalText}
        pendingCopay={pendingCopay}
      />
    </Card.Container>
  );
};

export default AppointmentCard;
